module.exports = __webpack_public_path__ + "img/pal.fdf22b95.png";